<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="userTypeModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      role="document"
    >
      <div class="modal-content">
        <form @submit="editUserType">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLongTitle"
            >
              View UserType
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div
              class="form-group row"
              :class="{'has-error': errorUpdateUserType.code !== ''}"
            >
              <label
                for="userTypeCode"
                class="col-sm-2 col-form-label font-weight-bolder"
              >CODE:</label>
              <div class="col col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="userTypeCode"
                  v-model="userType.code"
                  :readonly="!editableUsertype"
                  maxlength="10"
                >

                <span
                  class="help-block has-error"
                  v-if="errorUpdateUserType.code !== ''"
                >
                  <small><strong>{{ errorUpdateUserType.code }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group row"
              :class="{'has-error': errorUpdateUserType.name !== ''}"
            >
              <label
                for="userTypeName"
                class="col-sm-2 col-form-label font-weight-bolder"
              >NAME:</label>

              <div class="col col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="userTypeName"
                  v-model="userType.name"
                  :readonly="!editableUsertype"
                  maxlength="10"
                >

                <span
                  class="help-block"
                  v-if="errorUpdateUserType.code !== ''"
                >
                  <small><strong>{{ errorUpdateUserType.code }}</strong></small>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label
                for="userTypeStatus"
                class="col-sm-2 col-form-label font-weight-bolder"
              >STATUS</label>
              <div class="col col-sm-2">
                <input
                  type="checkbox"
                  name="userTypeStatus"
                  id="userTypeStatus"
                  class="form-control"
                  v-model="userType.status"
                  :disabled="!editableUsertype"
                >
              </div>

              <div class="col col-sm-2">
                <label class="col-sm-2 col-form-label">{{ userType.status ? 'ACTIVE':'INACTIVE' }}</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              id="submitBtn"
              type="submit"
              class="btn btn-warning btn-sm font-weight-bolder action"
            >
              <i class="fa fa-edit" />
              {{ editableUsertype ? 'SAVE':'EDIT' }}
            </button>

            <button
              id="cancelBtn"
              type="button"
              class="btn btn-secondary btn-sm font-weight-bolder action"
              data-dismiss="modal"
              @click="cancelEdit"
            >
              <i class="fa fa-ban" />
              {{ editableUsertype ? 'CANCEL':'CLOSE' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex';
    import $ from 'jquery';
    import {formMixins} from '../../../mixins/formMixins';

    export default {
        mixins: [formMixins],
        name: 'ViewUserType',
        data() {
            return {

            }
        },

        methods:{
            ...mapActions(['setEditableUserType','updateUserType']),

            //todo make a methods for the update and editable.
            async editUserType(e) {
                e.preventDefault();
                if(this.editableUsertype) {
                    if(await this.confirmUpdateAlert('Are you sure you want to update this user type.?', 'UPDATE')){
                        this.updateUserType(this.userType);
                    }
                }
                this.setEditableUserType();
            },
            //todo set the following editable into true || false
            cancelEdit() {
                let btn = document.getElementById('cancelBtn');
                if(this.editableUsertype) {
                    this.setEditableUserType();
                    btn.removeAttribute('data-dismiss');
                    btn.removeAttribute('data-target');
                } else {
                    btn.setAttribute('data-dismiss','modal');
                    btn.setAttribute('data-target','#userTypeModal');
                }
            }
        },
        computed: {
            ...mapGetters([
                'userType',
                'editableUsertype',
                'errorUpdateUserType'
            ]),
        },

        mounted:function() {
            $('#myModal').modal({backdrop: 'static', keyboard: false})
        },
    };
</script>

<style scoped>
    .action{
        font-weight: 0.9em;
    }
</style>
